import EventBase, { AnyEventUpdate, EventUpdate } from './EventBase'

export type BlockEventType = 'present' | 'absent'

export default interface BlockEvent extends EventBase {
  /// Type of block event
  readonly type: BlockEventType
  /// Created timestamp of this block event
  readonly createdAt: number
}

export interface BlockPresentEvent extends BlockEvent {
  readonly mapObject: {
    readonly id: string
    readonly type: 'player' | 'image'
    readonly userID: string
  }
}

export interface BlockAbsentEvent extends BlockEvent {
  readonly mapObject: {
    readonly id: string
    readonly type: 'player' | 'image'
  }
}

export function parseBlockEvent (payload: any): Array<BlockEvent> {
  switch (payload.type) {
    case 'present':
      const present: BlockPresentEvent = {
        id: payload.id,
        type: 'present',
        createdAt: payload.created_at,
        mapObject: {
          id: payload.map_object.id,
          type: payload.map_object.type,
          userID: payload.map_object.user.id
        },
        local: false,
        bySelf: false
      }
      return [present]
    case 'absent':
      const absent: BlockAbsentEvent = {
        id: payload.id,
        type: 'absent',
        createdAt: payload.created_at,
        mapObject: {
          id: payload.map_object.id,
          type: payload.map_object.type
        },
        local: false,
        bySelf: false
      }
      return [absent]
    case 'snapshot':
      let result: Array<BlockEvent> = []
      for (const subevent of payload.subevents) {
        result = result.concat(parseBlockEvent(subevent))
      }
      return result
  }
  return []
}

export function isBlockEventUpdate (
  eventUpdate: AnyEventUpdate
): eventUpdate is EventUpdate<BlockEvent> {
  return eventUpdate.tag === 'block'
}

export function isBlockPresentEvent (
  blockEvent: BlockEvent
): blockEvent is BlockPresentEvent {
  return blockEvent.type === 'present'
}

export function isBlockAbsentEvent (
  blockEvent: BlockEvent
): blockEvent is BlockAbsentEvent {
  return blockEvent.type === 'absent'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/events/BlockEvent.ts